module.exports = __webpack_public_path__ + "static/img/service_banana01.00aee40.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/service_banana01.png
// module id = +yvC
// module chunks = 0